// Dafult configuration
export const i18nConfig = {
  language: "en",
  fallBacklanguage: "en",
  languages: ["it", "en"]
};
